import React, {useEffect, useState} from "react";
import { Button, Grid, Typography } from "@mui/material";
import  Navbar  from '../../components/Navbar/Navbar';
import './Users.scss'
import { ListUsers } from "../../components";
import {CardUsers} from "../../components";
import { getAllUsers} from '../../redux/actions/user-actions'
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';

function Users (){
	const [openDetail , setOpenDetail]= useState(false);
	const dispatch = useDispatch()
	const getMembers = async () => dispatch(getAllUsers())
	const [members , setMembers] = useState([]);
	const notifySucess= (message) => toast.success(message);

	useEffect(()=>{
		loadData()
	},[])

	const loadData =async()=>{
		const res = await getMembers()
		setMembers(res.data) 
	}


	const 	handleClickNewUser =()=>{
		setOpenDetail(true);
	}

	const notificationMessage=(message)=>{
		notifySucess(message)
	}

	return(
		<Grid className='main-container mt-4'>
			<Navbar />
			<Grid className="container-page">
				<Grid container spacing={2}>
					<Grid item xs={6} align='left'>
						<Typography variant="h6" className="mb-1">
								Usuarios
						</Typography>
					</Grid>
					<Grid item xs={6} align='right'>
						<Button 
							variant="contained" 
							className="mb-1" 
							size="small"
							onClick={handleClickNewUser}
						>
							Nuevo usuario
						</Button>
					</Grid>
						{members.length>0  && <ListUsers 
						data={members} 
						columns={2} 
						updateData={loadData}
						notification={notificationMessage}
						/>}
				</Grid>
			</Grid>
			{
					openDetail && (
					<CardUsers
						item={null}
						openModal={openDetail}
						setOpenModal= {setOpenDetail}
						callback={loadData}
						notification={notificationMessage}
						isPartner={false}
					/>)
			}
			<ToastContainer 
					position="bottom-center"
					autoClose={1000}
			/>
		</Grid>
	);

}

export default Users;